// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mailing-item-info__create-mailing-preview {
    box-shadow: 2px 4px 16px rgb(137 150 155 / 20%);
    border-style: solid;
    border-width: medium;
    border-radius: 20px;
    border-color: #00dcff;
    margin-top: 5rem;
    margin-right: 7rem;
    width: 50rem;
    height: max-content;
    min-height: 10rem;
}

.mailing-item-info__image-block-input-field-image {
    margin: 2rem;
    margin-bottom: 0;
    width: auto;
    max-height: 60%;
    max-width: -webkit-fill-available;
    padding: 16px;
    border-style: solid;
    border-width: medium;
    border-color: #00dcff;
}

.mailing-item-info__create-mailing-preview__text-message {
    width: auto;
    max-height: 60%;
    max-width: -webkit-fill-available;
    border-style: solid;
    border-width: medium;
    border-color: #00dcff;
    padding: 16px;
    margin: 2rem;
    text-align: initial;
    word-break: break-word;
    white-space: pre-line;
}

.mailing-item-info__create-mailing-preview__text-message__text {
    margin-bottom: 1rem;
}

.mailing-item-info__create-mailing-preview__text-message__button {
    width: -webkit-fill-available;
    text-transform: none;
    height: auto;
    line-height: 20px;
    padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/mailing-item-info/CreateMailingInfo/CreateMailingInfoPreview/CreateMailingInfoPreview.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":[".mailing-item-info__create-mailing-preview {\r\n    box-shadow: 2px 4px 16px rgb(137 150 155 / 20%);\r\n    border-style: solid;\r\n    border-width: medium;\r\n    border-radius: 20px;\r\n    border-color: #00dcff;\r\n    margin-top: 5rem;\r\n    margin-right: 7rem;\r\n    width: 50rem;\r\n    height: max-content;\r\n    min-height: 10rem;\r\n}\r\n\r\n.mailing-item-info__image-block-input-field-image {\r\n    margin: 2rem;\r\n    margin-bottom: 0;\r\n    width: auto;\r\n    max-height: 60%;\r\n    max-width: -webkit-fill-available;\r\n    padding: 16px;\r\n    border-style: solid;\r\n    border-width: medium;\r\n    border-color: #00dcff;\r\n}\r\n\r\n.mailing-item-info__create-mailing-preview__text-message {\r\n    width: auto;\r\n    max-height: 60%;\r\n    max-width: -webkit-fill-available;\r\n    border-style: solid;\r\n    border-width: medium;\r\n    border-color: #00dcff;\r\n    padding: 16px;\r\n    margin: 2rem;\r\n    text-align: initial;\r\n    word-break: break-word;\r\n    white-space: pre-line;\r\n}\r\n\r\n.mailing-item-info__create-mailing-preview__text-message__text {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.mailing-item-info__create-mailing-preview__text-message__button {\r\n    width: -webkit-fill-available;\r\n    text-transform: none;\r\n    height: auto;\r\n    line-height: 20px;\r\n    padding-bottom: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
